<template>
  <q-dialog
    v-model="showDialog"
    v-bind="$attrs"
    :persistent="!$ui.isDev"
    v-on="$listeners"
  >
    <q-card>
      <q-card-section>
        <div class="text-h6">
          Bonne nouvelle !
        </div>
        <div>
          Une nouvelle version de {{ $APP.name }} est disponible
        </div>
        <ApplicationsLinksBloc v-if="$q.platform.is.mobile" />
        <div
          v-else
          class="q-pt-sm"
        >
          Une simple actualisation de votre navigateur est suffisante pour en profiter !
          <div>
            Si le message persiste, merci d'appuyer sur les touches "Ctrl + F5" de votre clavier.
          </div>
        </div>
      </q-card-section>
      <q-card-actions
        v-if="!$q.platform.is.mobile"
        align="right"
      >
        <q-btn
          color="primary"
          icon="fa fa-sync"
          label="Rafraîchir"
          @click="onReload"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import dialogComponentMixin from 'components/Dialog/dialogComponentMixin'
import ApplicationsLinksBloc from 'components/pages/ApplicationsLinks/ApplicationsLinksBloc'

export default {
  name: 'DialogAppVersion',
  components: { ApplicationsLinksBloc },
  mixins: [dialogComponentMixin],
  methods: {
    onReload () {
      // noinspection JSDeprecatedSymbols - Qui peut le plus peut le plus
      location.reload(true)
    }
  }
}
</script>

<style scoped>

</style>
